<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        @if (is2025) {
          {{ t('cohortProgress.description2025') }}
        } @else {
          {{ t('cohortProgress.description') }}
        }
      </p>
    </div>
  </div>
  <drdp-report-search [multiSelectClassrooms]="true" [multiSelectSites]="true" [hasSubfilters]="true" [multiSelectRatingPeriods]="true"
    [is2025]="is2025" (showReportClicked)="showReport($event)" (downloadReportClicked)="downloadReport($event)"
  (clearClicked)="handleClear()" [requiredFields]="requiredFields"></drdp-report-search>
  @if (!!reportData) {
    <div [innerHtml]="reportData! | safeHtml"></div>
  }
</div>
</ng-container>
